export const performanceVisualKeys = {
  all: ['performanceVisual'],

  lists: () => [...performanceVisualKeys.all, 'list'],

  adminList: (enabledFlag: boolean) => [...performanceVisualKeys.lists(), 'admin', enabledFlag],

  teacherList: (classId?: number) => [...performanceVisualKeys.lists(), 'teacher', classId ?? null],
};
